import type { SVGProps } from "react";

export function AlarmIcon(props: SVGProps<SVGSVGElement>) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
			<path d="M12 10l0 3l2 0" />
			<path d="M7 4l-2.75 2" />
			<path d="M17 4l2.75 2" />
		</svg>
	);
}
